export const getSvgElementFromSvgString = (string: string): SVGElement | null => {
	const parser = new DOMParser();
	const document = parser.parseFromString(string, 'image/svg+xml');
	return document.querySelector('svg');
};

export const getBase64ImageFromSvgElement = (element: SVGElement): string => {
	const mapString = new XMLSerializer().serializeToString(element);
	const encodedData = window.btoa(mapString);
	return `data:image/svg+xml;base64,${encodedData}`;
};
